import React from 'react';
import { Modal } from 'react-bootstrap';

import styles from './ConfirmationModal.css';

class ConfirmationModal extends React.Component {
  render() {
    const { showConfirmItemModal, onCancel, onConfirmSaveItem } = this.props;

    return (
      <Modal
        show={showConfirmItemModal}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <Modal.Header>
          <Modal.Title bsClass={`modal-title ${styles['modal-title']}`}>
            Save item
          </Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass={`modal-body ${styles.body}`}>
          <span className={styles['text-confirmation']}>
            Do you want to save this item?
          </span>
          <p className={styles['text-description']}>
            saving these changes will affect item details on all outlets
          </p>
        </Modal.Body>
        <Modal.Footer bsClass={`modal-footer ${styles.footer}`}>
          <span className="pull-right">
            <button
              className={`btn btn-default ${styles['btn-cancel']}`}
              type="button"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              className={`btn btn-primary ${styles['btn-confirm']}`}
              type="button"
              onClick={onConfirmSaveItem}
            >
              Save
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ConfirmationModal;
